/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let ProductOverviewImport;
let KeyFeaturesImport;
let ItemRelatedGroupsImport;
let RatingsAndReviewsImport;
let FeatureBasedRecommendationsImport;
let EducationalSummaryImport;

/** *********************
 * Product Overview
 ********************** */
export const ProductOverviewLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview-desktop" */
  '@thd-olt-component-react/product-overview/dist/ProductOverviewDesktop')
  .then((module) => {
    const { ProductOverviewDesktop } = module;
    ProductOverviewImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="product-overview">
          <ProductOverviewDesktop {...props} />
        </QueryProvider>
      );
    };
  });

export const ProductOverview = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview/dist/ProductOverviewDesktop')).ProductOverviewDesktop
  : (props) => <ProductOverviewImport {...props} />;

export const ProductOverviewModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview/dist/dataModel')).dataModel
  : {};

export const ProductOverviewMobileLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview-mobile" */
  '@thd-olt-component-react/product-overview/dist/ProductOverviewMobile')
  .then((module) => {
    const { ProductOverviewMobile } = module;
    ProductOverviewImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="product-overview">
          <ProductOverviewMobile {...props} />
        </QueryProvider>
      );
    };
  });

export const ProductOverviewMobile = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview/dist/ProductOverviewMobile')).ProductOverviewMobile
  : (props) => <ProductOverviewImport {...props} />;

/** *********************
 * Key Features (part of Product Overview)
 ********************** */
export const KeyFeaturesLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "product-overview" */
  '@thd-olt-component-react/product-overview')
  .then((module) => {
    const { KeyFeatures } = module;

    KeyFeaturesImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="key-product-features">
          <KeyFeatures {...props} />
        </QueryProvider>
      );
    };
  });

export const KeyFeatures = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).KeyFeatures
  : (props) => <KeyFeaturesImport {...props} />;

export const KeyFeaturesModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview')).KeyFeatures.dataModel
  : {};

/** *********************
 * IRG
 ********************** */
export const ItemRelatedGroupsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "item-related-groups-desktop" */
  '@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsDesktop')
  .then((module) => {
    const { ItemRelatedGroupsDesktop } = module;

    ItemRelatedGroupsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="item-related-groups">
          <ItemRelatedGroupsDesktop {...props} />
        </QueryProvider>
      );
    };
  });

export const ItemRelatedGroupsMobileLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "item-related-groups-mobile" */
  '@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsMobile')
  .then((module) => {
    const { ItemRelatedGroupsMobile } = module;

    ItemRelatedGroupsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="item-related-groups">
          <ItemRelatedGroupsMobile {...props} />
        </QueryProvider>
      );
    };
  });

export const ItemRelatedGroups = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsDesktop')).ItemRelatedGroupsDesktop
  : (props) => <ItemRelatedGroupsImport {...props} />;

export const ItemRelatedGroupsMobile = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups/dist/components/ItemRelatedGroupsMobile')).ItemRelatedGroupsMobile
  : (props) => <ItemRelatedGroupsImport {...props} />;

export const ItemRelatedGroupsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/item-related-groups/dist/components/dataModel')).dataModel
  : {};

/** *********************
 * FBR
 ********************** */
export const FeatureBasedRecommendationsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "feature-based-recommendations" */
  '@thd-olt-component-react/feature-based-recommendations')
  .then((module) => {
    const { FeatureBasedRecommendations } = module;

    FeatureBasedRecommendationsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="feature-based-recommendations">
          <FeatureBasedRecommendations {...props} />
        </QueryProvider>
      );
    };
  });

export const FeatureBasedRecommendations = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations
  : (props) => <FeatureBasedRecommendationsImport {...props} />;

export const FeatureBasedRecommendationsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations')).FeatureBasedRecommendations.dataModel
  : {};

/** *********************
 * Ratings and Reviews
 ********************** */
export const RatingsAndReviewsLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews" */
  '@thd-olt-component-react/ratings-and-reviews')
  .then((module) => {
    const { RatingsAndReviews } = module;

    RatingsAndReviewsImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="ratings-and-reviews">
          <RatingsAndReviews {...props} />
        </QueryProvider>
      );
    };
  });

export const RatingsAndReviews = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviews
  : (props) => <RatingsAndReviewsImport {...props} />;

export const RatingsAndReviewsModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews')).RatingsAndReviews.dataModel
  : {};

/** **********************
 * Educational Summary
 ********************** */
export const EducationalSummaryLoad = () => import(
  /* webpackPrefetch: true, webpackChunkName: "educational-summary" */
  '@thd-olt-component-react/educational-summary')
  .then((module) => {
    const { EducationalSummary } = module;
    EducationalSummaryImport = (props) => {
      return (
        <QueryProvider defaultVariables={props.qctx.defaultVariables.current} cacheKey="educational-summary">
          <EducationalSummary {...props} />
        </QueryProvider>
      );
    };
  });

export const EducationalSummary = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/educational-summary')).EducationalSummary
  : (props) => <EducationalSummaryImport {...props} />;

export const EducationalSummaryModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/educational-summary')).EducationalSummary.dataModel
  : {};
